import "Container/Home/Home.scss";

import React from 'react';
import { Carousel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { decode } from "html-entities";
import DisplayContributions from "../../Components/DisplayContributions/DisplayContributions";
import { sanitizedMsg } from "../../utils/htmlUtils";
import { isAdminKc, isRenderedAsAdmin } from "../../utils/keycloakUtils";
import { useDispatch, useSelector } from "react-redux";
import { updateKeycloak } from "../../Redux/keycloak/keycloakReducer";

function Home() {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const CONF = window?.confPub;
    const UI = CONF?.UI?.RECHERCHE_PERSONNE;
    const INPUTS = UI?.INPUTS;
    const ROUTES = CONF?.ROUTES;

    const {
        keycloakReduce,
        mnhPratique,
        messagesAccueil,
        loadingMessages,
    } = useSelector(state => ({
        ...state.keycloakReducer,
        ...state.resourcesReducer,
    }))

    return (
        <div className="container home pt-3">
            <Carousel className={ 'default-message-height' }>
                { !loadingMessages && messagesAccueil?.length > 0 && messagesAccueil?.map((message, index) => {

                    let corpsParsed = ""

                    if (message?.corps !== undefined && message?.corps !== '') {
                        try {
                            corpsParsed = JSON.parse(message.corps);
                        } catch (error) {
                            console.error("Failed to parse JSON:", error, message.corps);
                            corpsParsed = "Format du message invalide";
                        }
                    }

                    return (
                        <Carousel.Item key={ `message-${ index }` }>
                            <div
                                className={ 'message-window' }
                                dangerouslySetInnerHTML={ sanitizedMsg(corpsParsed) }>

                            </div>
                        </Carousel.Item>
                    )
                }) }
            </Carousel>

            <main id='content' className='mt-3'>

                <div className="row">

                    <div className="col-lg-6 col-xl-7 d-flex flex-column">
                        <DisplayContributions/>
                    </div>

                    <div className="col-lg-6 col-xl-5 d-flex flex-column">
                        <div className="card h-100">
                            <div className="card-header header-turquoise">
                                <h1 className="my-2">MNH PRATIQUE</h1>
                            </div>
                            <div className="card-body">
                                { mnhPratique?.length > 0 && mnhPratique.map((page, key) => {
                                    return (
                                        <div key={ `mnh-pratique${ key }` } className='nav-link-item-home '>
                                            <a href={ `/mnh-pratique${ page?.pageUrl }` } className='nav-link-home'>
                                                { `${ decode(page?.pageLibelle) }` }
                                            </a>
                                        </div>
                                    )
                                }) }
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            { isAdminKc(keycloakReduce?.decodedToken) ? (
                <div className="float-end mt-3">
                    <button className="btn btn-primary" type='button' onClick={ () => {
                        dispatch(updateKeycloak({ isRenderedAsAdmin: !keycloakReduce?.isRenderedAsAdmin }))
                    } }>
                        { isRenderedAsAdmin(keycloakReduce) ? "Mode utilisateur" : "Mode admin" }
                    </button>
                </div>
            ) : '' }
        </div>
    )
}

export default Home;